import LocalStorage from './LocalStorage'
import Api from './Api'
import swaller from '../Library/Tools/Swaller'

class AuthService {
  // Logout manuale (con conferma)
  async logout (navigate) {
    const res = await swaller.question('Confermi di voler effettuare il Logout?')
    if (res) {
      this.performLogout(navigate)
    }
  }

  // Logout automatico (senza conferma, con messaggio personalizzato)
  async autoLogout (message = 'Sessione scaduta per inattività. Sarai reindirizzato al login.', navigate = null) {
    try {
      await swaller.warning(message)
      this.performLogout(navigate)
    } catch (error) {
      // Forza il logout anche in caso di errore
      this.performLogout(navigate)
    }
  }

  salvaSessione ({ user, jwt }) {
    LocalStorage.set('intestazione', user.azienda.intestazione)
    LocalStorage.set('user', user)
    LocalStorage.set('_id', user._id)
    LocalStorage.set('jwt', jwt)
  }

  // Ricarica completa su /home: sidebar, sezioni e ogni pagina tengono in memoria dati dell'azienda precedente,
  // e la pagina corrente può essere il dettaglio di un documento che nell'altra azienda non esiste.
  async cambiaAzienda (aziendaId) {
    const sessione = await Api.switchAzienda(aziendaId)
    if (!sessione) return false
    this.salvaSessione(sessione)
    window.sessionStorage.clear() // filtri salvati con id dell'altra azienda
    window.location.assign('/home')
    return true
  }

  // Esegue il logout effettivo (pulizia dati + redirect)
  performLogout (navigate = null) {
    // Pulisce tutti i dati di sessione
    LocalStorage.clear()
    Api.setToken(null)

    // Reindirizza al login
    if (navigate && typeof navigate === 'function') {
      navigate('/login')
    } else {
      window.location.href = '/login'
    }
  }

  // Verifica se l'utente è loggato
  isLoggedIn () {
    const user = LocalStorage.get('user')
    return !!user
  }

  // Ottiene l'utente corrente
  getCurrentUser () {
    return LocalStorage.get('user')
  }
}

// Esporta un'istanza singleton
const authService = new AuthService()
export default authService
